"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const asText$1 = require("../richtext/asText.cjs");
const asText = (richTextField, ...configObjectOrTuple) => {
  if (richTextField) {
    const [configObjectOrSeparator] = configObjectOrTuple;
    let config;
    if (typeof configObjectOrSeparator === "string") {
      config = {
        separator: configObjectOrSeparator
      };
    } else {
      config = { ...configObjectOrSeparator };
    }
    return asText$1.asText(richTextField, config.separator);
  } else {
    return null;
  }
};
exports.asText = asText;
//# sourceMappingURL=asText.cjs.map
